import { getCustomProps, getNotCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface SavedFormula {
  id?: string
  name: string
  code: string
  description: string
  formula: string
  countries: any[]
  attachment?: string
}

export async function getSavedFormulas(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = [`countries ? :countryId`]
  if (search) {
    where.push(`CONCAT(name,code) ILIKE '%${search}%'`)
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          `ORDER BY (CASE WHEN code ~ '^[0-9]+$' THEN CAST(code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, code ${dataOrder[0]}`
        ])
      : (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = [
        "ORDER BY (CASE WHEN code ~ '^[0-9]+$' THEN CAST(code AS numeric) ELSE NULL END), code"
      ])
  // result
  const response: any = await getData({
    tables: ['pg_saved_formulas'],
    fields: ['id', 'code', 'name', 'updated_at', 'is_inactive'],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response[0]
}

export async function getSavedFormula(id: string): Promise<SavedFormula> {
  const data = await getData<any>({
    tables: ['pg_saved_formulas'],
    fields: [
      'id',
      'code',
      'name',
      'attachment',
      'countries',
      'description',
      'formula',
      'custom_fields as custom'
    ],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createSavedFormula(data: SavedFormula): Promise<boolean> {
  const response: any = await http.post('concept/saved-formulas', {
    ...getNotCustomProps(data),
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateSavedFormula(
  data: SavedFormula,
  id: string
): Promise<boolean> {
  const response: any = await http.put('concept/saved-formulas/' + id, {
    ...getNotCustomProps(data),
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateStateSavedFormula(
  id: string,
  state: boolean
): Promise<boolean> {
  const response: any = await http.put(`/concept/saved-formulas/${id}/enable`, {
    enable: !state
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
